import { createFileRoute } from "@tanstack/react-router";
import TestSupervivencia, { SURVIVAL_COPY } from "@/pages/TestSupervivencia";
import { SITE_URL } from "@/lib/site-url";

const c = SURVIVAL_COPY.es;
const ES = `${SITE_URL}/lp/test-supervivencia`;
const EN = `${SITE_URL}/en/retail-survival-test`;
const IMG = `${SITE_URL}/og-test-supervivencia.jpg`;
const ALT = "¿Tu negocio sobrevivirá? Test de supervivencia de Retail Lemon";
const SHARE_TITLE = "Test de supervivencia de tu negocio";
const SHARE_DESC = "Si tienes un negocio o vas a abrir uno, haz este test gratis.";
const QS = c.questions.map((q) => ({
  "@type": "Question",
  name: q.q,
  suggestedAnswer: q.a.map((a) => ({ "@type": "Answer", text: a })),
}));

export const Route = createFileRoute("/lp/test-supervivencia")({
  head: () => ({
    meta: [
      { title: c.title },
      { name: "description", content: c.description },
      { property: "og:title", content: SHARE_TITLE },
      { property: "og:description", content: SHARE_DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: ES },
      { property: "og:site_name", content: "Retail Lemon" },
      { property: "og:locale", content: "es_ES" },
      { property: "og:locale:alternate", content: "en_US" },
      { property: "og:image", content: IMG },
      { property: "og:image:secure_url", content: IMG },
      { property: "og:image:type", content: "image/jpeg" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: ALT },
      { name: "twitter:image", content: IMG },
      { name: "twitter:image:alt", content: ALT },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: SHARE_TITLE },
      { name: "twitter:description", content: SHARE_DESC },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [
      { rel: "canonical", href: ES },
      { rel: "alternate", hrefLang: "es", href: ES },
      { rel: "alternate", hrefLang: "en", href: EN },
      { rel: "alternate", hrefLang: "x-default", href: ES },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Quiz",
              "@id": `${ES}#quiz`,
              name: c.title,
              description: c.description,
              url: ES,
              inLanguage: "es",
              image: IMG,
              isAccessibleForFree: true,
              educationalUse: "self-assessment",
              about: { "@type": "Thing", name: "Supervivencia de pequeños comercios" },
              provider: { "@type": "Organization", name: "Retail Lemon", url: SITE_URL },
              hasPart: QS,
            },
            {
              "@type": "WebApplication",
              name: c.title,
              url: ES,
              applicationCategory: "BusinessApplication",
              operatingSystem: "Web",
              inLanguage: "es",
              offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
              publisher: { "@type": "Organization", name: "Retail Lemon", url: SITE_URL },
            },
          ],
        }),
      },
    ],
  }),
  component: () => <TestSupervivencia routeLang="es" />,
});
